import styled from 'styled-components';

/**
 * Estilização do componente GridHorizontalTwoMaps
 */
export const Wrap = styled.div`
    font-size: 8px;
    width: 100%;
    
    /* Container principal para layout vertical (lado a lado) */
    .two-maps-horizontal-container {
        display: flex;
        width: 100%;
        gap: 2px; /* Espaço entre os mapas */
    }
    
    /* Container para layout horizontal (um acima do outro) */
    .two-maps-vertical-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 10px; /* Espaço entre mapas superior e inferior */
    }
    
    /* Container individual de cada mapa */
    .single-map-grid {
        position: relative;
        
        /* Para layout vertical: cada mapa ocupa metade da largura */
        &.vertical-layout {
            width: calc(50% - 1px);
        }
        
        /* Para layout horizontal: cada mapa ocupa toda a largura */
        &.horizontal-layout {
            width: 100%;
        }
        
        /* Adiciona padding interno para evitar sobreposição */
        .coordinates {
            padding: 0 8px; /* Espaço interno nas bordas */
            position: relative;
            
            /* Para o mapa da direita, adiciona padding extra à esquerda */
            &.right-map {
                padding-left: 12px;
            }
        }
    }
    
    /* Container das coordenadas */
    .coordinates {
        display: flex;
        position: relative;
        width: 100%;
        min-height: 20px; /* Altura mínima para evitar sobreposição */
        padding: 0 2px; /* Padding mínimo nas bordas */
        
        /* Para o mapa da direita, adiciona padding extra à esquerda */
        &.right-map {
            padding-left: 8px; /* Espaço extra para separar dos mapas */
        }
    }
    
    /* Estilos base para todas as coordenadas */
    .coordinate-item {
        position: absolute;
        font-size: 8px;
        white-space: nowrap;
        text-align: center;
        padding: 1px 3px; /* Padding para melhor leitura */

        

        
        /* Hover para melhor visualização */
        &:hover {
            background: rgba(255, 255, 255, 1);
            border-color: #2E7D32;
            z-index: 10;
        }
    }
    
    /* Posicionamento específico para 4 coordenadas */
    .coordinates1 {
        position: relative;        
        left: 2%; /* Primeira coordenada bem visível */
    }
    
    .coordinates2 {
        position: relative;        
        left: 18%; /* Segunda coordenada */
    }
    
    .coordinates3 {
        position: relative;        
        left: 34%; /* Terceira coordenada */
    }
    
    .coordinates4 {
        position: relative;        
        left: 43%; /* Quarta coordenada com margem */
    }
    
    /* Labels identificadores dos mapas */
    .map-label {
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 10px;
        font-weight: bold;
        color: #2E7D32;
        background: rgba(255, 255, 255, 0.9);
        padding: 2px 6px;
        border-radius: 3px;
        border: 1px solid #4CAF50;
        z-index: 10;
        pointer-events: none;
        
        /* Para layout horizontal, posiciona à esquerda */
        &.horizontal-layout {
            top: 2px;
            left: 8px;
            transform: none;
        }
    }
    
    /* Estilo especial para modo dois mapas */
    .two-maps-mode {
        /* Grid específico para dois mapas com estilo diferenciado */
        .coordinates {
            border-bottom: 2px solid #2E7D32;
            position: relative;
            
            &::before {
                content: '';
                position: absolute;
                bottom: -4px;
                left: 0;
                right: 0;
                height: 1px;
                background: #4CAF50;
                opacity: 0.5;
            }
        }
    }
    
    /* Responsividade para telas menores */
    @media (max-width: 768px) {
        font-size: 7px;
        
        .coordinates1 { left: 2%; }
        .coordinates2 { left: 16%; }
        .coordinates3 { left: 32%; }
        .coordinates4 { left: 44%; }
    }
`;


export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 2px;
`;

/**
 * Container flexível para diferentes layouts
 */
export const FlexContainer = styled.div`
    display: flex;
    width: 100%;
    
    &.vertical {
        flex-direction: row;
        gap: 2px;
    }
    
    &.horizontal {
        flex-direction: column;
        gap: 10px;
    }
`;

/**
 * Wrapper individual para cada mapa
 */
export const MapGridWrapper = styled.div`
    position: relative;
    
    /* Tamanhos conforme layout */
    ${(props) => props.layout === 'vertical' ? `
        width: calc(50% - 1px);
    ` : `
        width: 100%;
    `}
    
    /* Estilo diferenciado para dois mapas */
    ${(props) => props.twoMapsMode ? `
        .coordinate-item {
            color:#5E5E5E;
            font-weight: 500;
        }
    ` : ''}
`;

